module.exports = __webpack_public_path__ + "img/customer_service.c5937dd5.svg";